import { useEffect, useCallback } from 'react';

const listeners = new Map();

export const useEventBus = (eventName, callback) => {
  const subscribe = useCallback(() => {
    if (!listeners.has(eventName)) {
      listeners.set(eventName, new Set());
    }
    listeners.get(eventName).add(callback);

    return () => {
      const eventListeners = listeners.get(eventName);
      if (eventListeners) {
        eventListeners.delete(callback);
        if (eventListeners.size === 0) {
          listeners.delete(eventName);
        }
      }
    };
  }, [eventName, callback]);

  useEffect(() => {
    return subscribe();
  }, [subscribe]);
};

export const emit = (eventName) => {
  const eventListeners = listeners.get(eventName);
  if (eventListeners) {
    eventListeners.forEach(callback => callback());
  }
};
